import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import Patient from '../model/Patient'
import { AppThunk } from '../store'
import PatientsPage from 'model/PatientsPage'
import PatientsPagesRepository from 'clients/db/PatientsPagesRepository'

interface PatientsState {
  isLoading: boolean
  patients: Patient[]
  patientsPages: PatientsPage[]
}

const initialState: PatientsState = {
  isLoading: false,
  patients: [],
  patientsPages: [],
}

function startLoading(state: PatientsState) {
  state.isLoading = true
}

const patientsSlice = createSlice({
  name: 'patients',
  initialState,
  reducers: {
    fetchPatientsStart: startLoading,
    fetchPatientsFirstPageSuccess: (state, { payload }: PayloadAction<PatientsPage>) => {
      state.isLoading = false
      state.patientsPages = [payload]
    },
    fetchPatientsPageSuccess: (state, { payload }: PayloadAction<PatientsPage>) => {
      state.isLoading = false
      state.patientsPages = [...state.patientsPages, payload]
    },
  },
})
export const {
  fetchPatientsStart,
  fetchPatientsFirstPageSuccess,
  fetchPatientsPageSuccess,
} = patientsSlice.actions

export const fetchPatientsPage = (
  bookmark: string,
  searchString?: string,
  selector?: any,
  sort?: any,
): AppThunk => async (dispatch) => {
  dispatch(fetchPatientsStart())

  let patientsPages
  if (searchString === undefined || searchString.trim() === '') {
    patientsPages = await PatientsPagesRepository.searchPatientsPage(bookmark, selector, sort)
  } else {
    patientsPages = await PatientsPagesRepository.searchPatientsPageText(
      bookmark,
      searchString,
      selector,
      sort,
    )
  }

  if (bookmark === '') {
    dispatch(fetchPatientsFirstPageSuccess(patientsPages))
  } else {
    dispatch(fetchPatientsPageSuccess(patientsPages))
  }
}

export const fetchPatientsPageGroup = (
  groupId: string,
  bookmark: string,
  searchString?: string,
): AppThunk => async (dispatch) => {
  dispatch(fetchPatientsStart())

  let patientsPages
  if (searchString === undefined || searchString.trim() === '') {
    patientsPages = await PatientsPagesRepository.searchPatientsPageInGroup(groupId, bookmark)
  } else {
    patientsPages = await PatientsPagesRepository.searchPatientsPageInGroupText(
      groupId,
      bookmark,
      searchString,
    )
  }

  if (bookmark === '') {
    dispatch(fetchPatientsFirstPageSuccess(patientsPages))
  } else {
    dispatch(fetchPatientsPageSuccess(patientsPages))
  }
}

export const fetchPatientsPageMainGroup = (
  bookmark: string,
  searchString?: string,
): AppThunk => async (dispatch) => {
  dispatch(fetchPatientsStart())

  let patientsPages
  if (searchString === undefined || searchString.trim() === '') {
    patientsPages = await PatientsPagesRepository.searchPatientsPageInMainGroup(bookmark)
  } else {
    patientsPages = await PatientsPagesRepository.searchPatientsPageInMainGroupText(
      bookmark,
      searchString,
    )
  }

  if (bookmark === '') {
    dispatch(fetchPatientsFirstPageSuccess(patientsPages))
  } else {
    dispatch(fetchPatientsPageSuccess(patientsPages))
  }
}

export default patientsSlice.reducer
